import Speaker from './Speaker';

function Speakers({speakers}) {
	return (
		<div className={'event-details'}>
			{
				speakers.map(speaker => {
					return <Speaker key={speaker.ID} speaker={speaker} showToggle={true}/>
				})
			}
		</div>
	)
}

export default Speakers;
